// Module
var code = "<compliance-document-definitions\n  folder-id=\"vm.folderId\"\n></compliance-document-definitions>\n";
// Exports
module.exports = code;